import React from 'react';
import { cardStyles } from './Card.styles';

const Card = ({
  children,
  variant = 'default',
  padding = 'md',
  hoverable = false,
  onClick,
  className = '',
  ...props
}) => {
  const classes = [
    cardStyles.base,
    cardStyles.variants[variant],
    cardStyles.padding[padding],
    hoverable ? cardStyles.hoverable : '',
    onClick ? 'cursor-pointer' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div onClick={onClick} className={classes} {...props}>
      {children}
    </div>
  );
};

Card.Header = ({ children, className = '' }) => (
  <div className={`border-b border-slate-100 dark:border-slate-700/60 pb-4 mb-4 ${className}`}>
    {children}
  </div>
);

Card.Body = ({ children, className = '' }) => (
  <div className={className}>{children}</div>
);

Card.Footer = ({ children, className = '' }) => (
  <div className={`border-t border-slate-100 dark:border-slate-700/60 pt-4 mt-4 ${className}`}>
    {children}
  </div>
);

Card.Title = ({ children, className = '' }) => (
  <h3 className={`text-base font-semibold text-slate-900 dark:text-slate-100 ${className}`}>
    {children}
  </h3>
);

Card.Description = ({ children, className = '' }) => (
  <p className={`text-sm text-slate-500 dark:text-slate-400 mt-0.5 ${className}`}>
    {children}
  </p>
);

export default Card;
